import { decodeNumber, encodeString } from 'use-query-params'

import { UserRole } from '../Constants'

export const isMATask = (task) => task?.identifier?.startsWith('MA-') ?? false
export const isSupportTask = (task) => task?.identifier?.startsWith('CS-') ?? false
export const isPharmacyTask = (task) => task?.identifier?.startsWith('PH-') ?? false
export const isProviderTask = (task) => task?.identifier?.startsWith('P-') ?? false
export const isEscalationTask = (task) => task?.identifier?.startsWith('E-') ?? false

export const getUserRoleFromTask = (task) => {
  if (isMATask(task)) return UserRole.MA
  if (isSupportTask(task)) return UserRole.Support
  if (isPharmacyTask(task)) return UserRole.Pharmacy
  if (isProviderTask(task)) return UserRole.Provider
  if (isEscalationTask(task)) return UserRole.Admin
  return null
}

export const TaskParam = {
  encode: (str) => encodeString(str),
  decode: (input) => {
    let s = typeof input === 'string' ? input.match(/\d+/g)?.[0] : input
    return decodeNumber(s)
  },
}
